/** 将品牌主色等硬编码替换为 currentColor，便于用 CSS 主题变量控制 */

const THEME_COLOR_PATTERNS: RegExp[] = [
  /#0456AD/gi,
  /#0057B4/gi,
  /#0057FF/gi,
  /#409eff/gi,
  /#0[dD]6[bB][cC]4/gi,
  /#034[aA]94/gi,
  /#337[eE]cc/gi,
  /#66[bB]1[fF]{2}/gi,
]

/** 固定色（白/浅灰描边等）不参与主题替换 */
const PRESERVE_COLOR_PATTERNS: RegExp[] = [
  /#fff\b/gi,
  /#ffffff\b/gi,
  /#FFFFFF\b/g,
  /\bwhite\b/gi,
]

/** 中性图标色（如 #111）在 monochrome 模式下随文字色 */
const MONO_COLOR_PATTERNS: RegExp[] = [
  /#111111/gi,
  /#0[cC]0[cC]0[cC]/gi,
  /#303133/gi,
  /#606266/gi,
]

export interface NormalizeSvgOptions {
  /** 将 #111 等也改为 currentColor，用于单色操作图标 */
  monochrome?: boolean
}

/** 从原始 SVG 推断显示尺寸：优先 width/height 属性，viewBox 仅作兜底且忽略 1024 类设计坐标系 */
export function inferSvgDefaultSize (raw: string): number {
  const width = raw.match(/\bwidth\s*=\s*["'](\d+(?:\.\d+)?)/i)
  if (width) return Number(width[1])
  const height = raw.match(/\bheight\s*=\s*["'](\d+(?:\.\d+)?)/i)
  if (height) return Number(height[1])
  const viewBox = raw.match(/viewBox\s*=\s*["']([^"']+)["']/i)
  if (viewBox) {
    const parts = viewBox[1].trim().split(/[\s,]+/).map(Number)
    if (parts.length >= 4 && parts.every(n => Number.isFinite(n))) {
      const w = parts[2]
      const h = parts[3]
      if (w > 0 && h > 0 && w <= 128 && h <= 128) return Math.max(w, h)
    }
  }
  return 16
}

export function normalizeSvgForTheme (raw: string, options: NormalizeSvgOptions = {}): string {
  let svg = raw.trim()
  svg = svg.replace(/\swidth="[^"]*"/gi, '')
  svg = svg.replace(/\sheight="[^"]*"/gi, '')
  svg = svg.replace(/\swidth='[^']*'/gi, '')
  svg = svg.replace(/\sheight='[^']*'/gi, '')
  if (!/class="/i.test(svg)) {
    svg = svg.replace(/<svg/i, '<svg class="cm-svg-icon__svg" width="100%" height="100%"')
  } else {
    svg = svg.replace(/<svg/i, '<svg width="100%" height="100%"')
    svg = svg.replace(/class="/i, 'class="cm-svg-icon__svg ')
  }
  const preserved: string[] = []
  for (const re of PRESERVE_COLOR_PATTERNS) {
    svg = svg.replace(re, (match) => {
      const token = `__CM_PRESERVE_${preserved.length}__`
      preserved.push(match)
      return token
    })
  }
  for (const re of THEME_COLOR_PATTERNS) {
    svg = svg.replace(re, 'currentColor')
  }
  preserved.forEach((color, index) => {
    svg = svg.replace(`__CM_PRESERVE_${index}__`, color)
  })
  if (options.monochrome) {
    for (const re of MONO_COLOR_PATTERNS) {
      svg = svg.replace(re, 'currentColor')
    }
  }
  return svg
}

/** SVG icon key (path under src/, minus .svg extension), e.g. "assets/icons/lang" */
export type SvgIconRegistryKey = string
